export { HotelAccommodationDesktopView } from "./Desktop/HotelAccommodationDesktopView";
export { AccommodationView } from "./Mobile/AccommodationView";
export { HotelAccommodationView } from "./Mobile/HotelAccommodationView";